import React from 'react';

import { useTeam, useSeason } from '../shared/hooks';
import { useBreadcrumbs, usePath } from '../../hooks';
import LineupSummaryList from './LineupsSummary';
import { useLineupSummary } from './useLineupSummary';
import { seasonName, teamName } from '../../lib/format';

function createBreadcrumbs(team, season, pathTo) {
  return [
    { title: 'Teams', url: pathTo('teams') },
    { title: `[${seasonName(season)}] ${teamName(team)}`, url: pathTo('team') },
    { title: 'Lineups' },
  ];
}

const LineupSummaryPage = ({ leagueId, seasonId, teamId }) => {
  const team = useTeam(teamId);
  const season = useSeason(seasonId);
  const pathTo = usePath(leagueId, seasonId, teamId);
  const summary = useLineupSummary(leagueId, seasonId, teamId, pathTo);

  useBreadcrumbs(createBreadcrumbs, [team, season, pathTo]);

  return (
    <LineupSummaryList
      team={team}
      summary={summary}
      pathTo={pathTo}
      season={season}
    />
  );
};

export default LineupSummaryPage;
